import React, {useState} from 'react'
import PropTypes from 'prop-types'
import {updateTenantFee} from "../../../../../../services/api/apiCustomerHub";
import parseToken from "../../../../../../helpers/parseToken";
import {message, Popconfirm} from "antd";
import checkRole from "../../../../../../helpers/checkRole";
import TenantFeeAdd from "./TenantFeeAdd";
import TenantFeeEditModal from "./TenantFeeEditModal";
import {formatCurrency} from "../../../../../../helpers/convertArrayToObject";

TenantFeeBlock.propTypes = {
    custId: PropTypes.string
}

function TenantFeeBlock(props) {
    const {custId, listTelco, fetchTenantFee, listTenantFee} = props
    const isEdit = checkRole('menu.customerhub.editFee')
    const decodeToken = parseToken()
    const [editItem, setEditItem] = useState(null)
    const [isEditOpen, setIsEditOpen] = useState(false)

    const handleDelete = async (id) => {
        try {
            const payload = {
                tenantFeeId: id,
                status: 0,
                tenantId: custId
            }
            const response = await updateTenantFee(decodeToken.sub, payload)

            const {success, error_message} = response

            if (parseInt(success) !== 1) {
                return message.error(error_message)
            }

            message.success('Xóa thành công!')
            fetchTenantFee()
        } catch (e) {
            message.error(e.message)
        }
    }

    const handleEdit = (item) => {
        setEditItem(item)
        setIsEditOpen(true)
    }

    const toggleEditModal = () => {
        setIsEditOpen(false)
        setEditItem(null)
    }

    return (
        <div className="BlockCenter">
            <div className="headerBlock d-flex align-items-start justify-content-between">
                <h3>Giá cước</h3>
            </div>
            <div className="ContentPage">
                <div className="CustomersTable">
                    <table>
                        <thead className="CustomersHead">
                        <tr>
                            <th>Gói cước</th>
                            <th>Hướng</th>
                            <th>Giá</th>
                            <th className="Actions"/>
                        </tr>
                        </thead>
                        <tbody className="CustomersBody">
                        {
                            listTenantFee.map(item => {
                                return (
                                    <tr className="CustomersItem" key={item?.tenantFeeId}>
                                        <td>{item?.description}</td>
                                        <td>{item?.telco}</td>
                                        <td>{item?.fee ? formatCurrency(Number(item.fee), 'en') : item?.fee}</td>
                                        <td align="right">
                                            {isEdit && (
                                                <span className="d-flex align-items-center justify-content-end" style={{gap: '8px'}}>
                                                    <span
                                                        className="material-icons cursor-pointer text-primary"
                                                        onClick={() => handleEdit(item)}
                                                        title="Sửa"
                                                    >edit</span>
                                                    <Popconfirm placement="top" title="Bạn chắc chắn muốn xóa?"
                                                                onConfirm={() => handleDelete(item?.tenantFeeId)}
                                                                okText="Yes"
                                                                cancelText="No">
                                                        <span
                                                            className="material-icons cursor-pointer text-danger">delete</span>
                                                    </Popconfirm>
                                                </span>
                                            )}
                                        </td>
                                    </tr>
                                )
                            })
                        }
                        </tbody>
                        {isEdit && (
                            <tfoot className="CustomersBody">
                            <tr className="CustomersItem">
                                <td colSpan={3}/>
                                <td className="Actions" align="right">
                                    <TenantFeeAdd custId={custId} listTelco={listTelco}
                                                  fetchTenantFee={fetchTenantFee}/>
                                </td>
                            </tr>
                            </tfoot>
                        )}
                    </table>
                </div>
            </div>
            {isEditOpen && (
                <TenantFeeEditModal
                    isOpen={isEditOpen}
                    toggleModal={toggleEditModal}
                    feeItem={editItem}
                    custId={custId}
                    listTelco={listTelco}
                    fetchTenantFee={fetchTenantFee}
                />
            )}
        </div>
    )
}

export default TenantFeeBlock
